import React, { useCallback, useEffect, useState } from 'react';
import Logos from '../Logos/components/Logos/Logos';
import { useHistory, useLocation } from 'react-router-dom';
import LogoEditor from '../Logos/components/LogoEditor/LogoEditor';
import styles from './Branding.module.scss';
import TextPanels from '../TextPanels/components/TextPanels/TextPanels';
import TextPanelManagementEditor from '../TextPanels/components/TextPanelEditor/TextPanelManagementEditor';
import { Colors } from '../Colors/Colors';
import SubtitleStyle from '../SubtitleStyle/SubtitleStyle';

const INITIAL_LOGO = { id: null, isEdit: false };
const INITIAL_TEXT_PANEL = { id: null, isEdit: false }

export const Branding = ({ companyId = null }) => {
    const [logoToEdit, setLogoToEdit] = useState(INITIAL_LOGO);
    const [textPanelToEdit, setTextPanelToEdit] = useState(INITIAL_TEXT_PANEL);
    const [colors, setColors] = useState([]);
    const history = useHistory();
    const { state, search } = useLocation();

    const handleOpenEditor = useCallback(
        (key, id) => {
            history.push({ pathname: `/eg/company-settings`, state: { ...state, [key]: id }, search });
        },
        [state, search]
    );

    const handleOpenLogoEditor = useCallback(
        (id) => {
            handleOpenEditor('logoId', id);
        },
        [handleOpenEditor]
    );

    const handleOpenTextPanelsEditor = useCallback(
        (id) => {
            handleOpenEditor('textPanelId', id);
        },
        [handleOpenEditor]
    );

    const handleCloseEditor = useCallback(() => {
        history.goBack();
    }, []);

    useEffect(() => {
        if (state.option) {
            if (state?.logoId) {
                setLogoToEdit({ id: state.logoId, isEdit: true });
            } else if (state?.textPanelId) {
                setTextPanelToEdit({ id: state.textPanelId, isEdit: true });
            } else {
                setTextPanelToEdit(INITIAL_TEXT_PANEL);
                setLogoToEdit(INITIAL_LOGO);
            }
        }
    }, [state]);

    if (logoToEdit.isEdit) {
        return <LogoEditor logoId={logoToEdit.id} onClose={handleCloseEditor} companyId={companyId} />;
    }
    if (textPanelToEdit.isEdit) {
        return <TextPanelManagementEditor colors={colors} textPanelId={textPanelToEdit.id} onClose={handleCloseEditor} companyId={companyId} />;
    }
    return (
        <div className={styles.wrapper}>
            <Logos handleOpenEditor={handleOpenLogoEditor} companyId={companyId} />
            <Colors companyId={companyId} updateColors={setColors} />
            <TextPanels handleOpenEditor={handleOpenTextPanelsEditor} companyId={companyId} />
            <SubtitleStyle colors={colors} companyId={companyId} />
        </div>
    );
}